
      document.addEventListener('DOMContentLoaded', function() {
      const thumbnails = document.querySelectorAll('.product__thumb');
      const mainImageZoomTrigger = document.querySelector('.js-photoswipe__zoom');
      if (thumbnails.length > 0 && mainImageZoomTrigger) {

        thumbnails.forEach(thumbnail => {
          thumbnail.addEventListener('click', function(e) {
            setTimeout(() => {
              mainImageZoomTrigger.click();
            }, 150); 

          });
        });
      }

      var viewMoreBtn = document.getElementById('viewMoreGalleryBtn');
    
    // Page load hone par sabhi hidden thumbnails ko select kar lein
    var extraThumbs = document.querySelectorAll('.hide-extra-thumbnail');
    
    if (viewMoreBtn && extraThumbs.length > 0) {
      var isExpanded = false; // Yeh track karega ki images open hain ya closed
      
      viewMoreBtn.addEventListener('click', function(e) {
        e.preventDefault();
        
        if (!isExpanded) {
          // Agar images hidden hain, toh unhe SHOW karein
          extraThumbs.forEach(function(thumb) {
            thumb.classList.remove('hide-extra-thumbnail');
          });
          // Button ka text badal kar "View less" kar dein
          viewMoreBtn.innerText = 'View less';
          isExpanded = true;
          
        } else {
          // Agar images show ho rahi hain, toh unhe wapas HIDE karein
          extraThumbs.forEach(function(thumb) {
            thumb.classList.add('hide-extra-thumbnail');
          });
          // Button ka text wapas "View more" kar dein
          viewMoreBtn.innerText = 'View more';
          isExpanded = false;
        }
      });
    } else if (viewMoreBtn) {
      // Agar 7 se kam images hain, toh button ko hide hi rakhein
      viewMoreBtn.parentElement.style.display = 'none';
    }
    });


